var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleskillLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 633,
    height: 147,
    viewBox: "0 0 633 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 92.26V120.76L17.5 122.26H0V31.26H31.5C77.51 31.26 71.95 92.26 38.5 92.26H19ZM19 76.26L20.5 75.26H36.5C49.59 75.26 51.66 48.26 34.5 48.26H19V76.26Z",
    fill: "#004DC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235 114.26V146.26H218V58.26H235V65.26C262.25 42.01 298.16 73.76 282.51 105.27C273.7 123.02 249.11 129.26 235 114.26ZM263.64 76.62C246.32 60.4 223.31 87.81 239.52 103.24C255.94 118.86 280.86 92.73 263.64 76.62Z",
    fill: "#004DC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.01 105.28L400.5 95.28C407.02 106.91 430.01 113.84 434.98 97.65C436.11 81.55 395.85 87.86 392.09 62.66C386.99 28.44 433 20.89 448.56 45.24L437.5 55.24C431.09 41.16 398.43 49.98 412.03 62.73C421.71 71.8 448.43 67.28 451.75 91C456.92 127.94 402.37 132.94 387.01 105.28Z",
    fill: "#004DC3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477 31.26V80.76L476.49 83.25C477.51 82.27 478.51 81.27 479.51 80.26C482.26 77.48 496.08 58.25 497.5 58.25H517L493.09 86.75L521 121.25H500.5L477.98 92.26L477 93.75V121.25H460V31.26H477Z",
    fill: "#004DC3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M384.001 95.26H336.001C340.381 111.84 359.101 113.13 370.501 102.23L380.841 111.55C363.831 132 323.561 124.55 320.111 96.64C313.741 45.09 390.831 44.13 383.991 95.26H384.001ZM368.001 83.26C364.961 66.42 340.641 67.42 337.001 83.26H368.001Z",
    fill: "#004DC3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.999 95.26H85.9991C89.7291 112.21 109.179 112.84 120.359 102.34L129.919 111.62C114.029 132.11 73.7291 124.45 70.1191 97.65C63.0891 45.4 139.579 43.72 133.999 95.27V95.26ZM88.4991 83.26H115.499L116.989 84.26C116.459 65.87 88.8391 67.76 87.0091 84.26L88.4991 83.26Z",
    fill: "#004DC3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.809 57.55C218.499 54.69 221.899 120.94 178.459 123.24C130.569 125.78 129.029 60.29 172.809 57.55ZM171.729 73.5C154.259 76.61 153.439 104.51 171.939 107.82C199.099 112.67 199.269 68.59 171.729 73.5Z",
    fill: "#004DC3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M312 31.26H295V121.26H312V31.26Z",
    fill: "#004DC3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M570 31.26V121.26H553V32.26L570 31.26Z",
    fill: "#004DC3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M597 31.26V121.26H580L581.5 31.26H597Z",
    fill: "#004DC3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M542 58.26H525V121.26H542V58.26Z",
    fill: "#004DC3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M525.321 47.94C518.441 40.2 527.001 28.1 537.551 33.2C549.731 39.09 535.411 59.29 525.321 47.94Z",
    fill: "#004DC3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M616 3.4248C623.497 3.4248 629.575 9.50273 629.575 17C629.575 24.4973 623.497 30.5752 616 30.5752C608.503 30.5752 602.425 24.4973 602.425 17C602.425 9.50273 608.503 3.4248 616 3.4248Z",
    stroke: "#004DC3",
    strokeWidth: 2.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M613.721 16.5162H616.496C616.978 16.5161 617.446 16.4467 617.768 16.3179C618.102 16.184 618.441 15.981 618.713 15.7769C618.949 15.5996 619.074 15.3618 619.214 15.0132C619.346 14.6832 619.412 14.3538 619.412 13.9537C619.412 13.5537 619.346 13.225 619.214 12.8951C619.074 12.5464 618.949 12.3078 618.713 12.1304C618.43 11.9181 618.169 11.7236 617.778 11.5933L617.768 11.5904V11.5894C617.447 11.4611 616.979 11.3912 616.425 11.3912H613.721V16.5162ZM623.354 25.4879H619.989L619.933 25.3824L616.589 19.1832H613.721V25.5582H610.487V8.65387H616.496C617.32 8.65389 618.087 8.76536 618.798 8.93805L619.099 9.0152L619.104 9.01617V9.01715C619.745 9.20979 620.329 9.51312 620.806 9.82965L621.004 9.96637L621.011 9.97125L621.018 9.97711C621.528 10.4144 621.983 10.9393 622.211 11.6246C622.424 12.2639 622.645 12.9985 622.646 13.8121C622.646 14.9793 622.353 15.9427 621.83 16.69L621.823 16.6998C621.286 17.3717 620.614 17.9909 619.751 18.3736L623.33 25.0513L623.354 25.0953V25.4879Z",
    fill: "#004DC3",
    stroke: "#004DC3",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleskillLogo);
export default __webpack_public_path__ + "static/media/peopleskillLogo.529c89deb0ec6dd63fb262efb6d57134.svg";
export { ForwardRef as ReactComponent };